module.exports = __webpack_public_path__ + "assets/img/A1.f97dc623.png";